/**
 * user模块接口列表
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const configure = {
	/**
	 * 获取所有菜单
	 */
	getAllmenu(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/menu/all-list`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新或添加菜单
	 */
	updateMenu(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/menu/update`,
			headers: {
				'Content-Type': 'application/json; charset=UTF-8'
			},
			data
		});
	},
	/**
	 * 删除菜单
	 */
	deleteMenu(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/menu/delete`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据菜单id获取菜单信息
	 */
	getMenuData(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/menu/get-one-menu`,
			data: qs.stringify(data)
		});
	}
};

export default configure;
